/* Archiveren van een organisatie of contact: deleted_at zetten, zoals bij projecten. Het
 * Archief (/crm/archief) zet ze terug. Nooit echt verwijderen: een DELETE op
 * organizations neemt via ON DELETE CASCADE onder meer portal_users, fe_machines en
 * battery_allocations mee, en op contacts portal_users en opportunity_contacts.
 *
 * Een organisatie met lopende projecten wordt niet gearchiveerd: die projecten zouden
 * dan naar een organisatie wijzen die nergens meer te zien is.
 *
 * Relatieve imports (geen @/), zodat de toetsen dit bestand zonder bundel lezen. */

import type { RelatieClient } from './organisaties';

export class ArchiveerWeigering extends Error {
  constructor(bericht: string) {
    super(bericht);
    this.name = 'ArchiveerWeigering';
  }
}

/** Waarom deze organisatie (nog) niet gearchiveerd kan worden, of null. */
export function archiveerBezwaar(projecten: number): string | null {
  if (projecten > 0) {
    return `Deze organisatie heeft nog ${projecten === 1 ? 'een project' : `${projecten} projecten`}. Archiveer die eerst, of koppel ze aan een andere organisatie.`;
  }
  return null;
}

async function zetGearchiveerd(client: RelatieClient, tabel: 'organizations' | 'contacts', id: string, wat: string) {
  const nu = new Date().toISOString();
  const { data, error } = await client
    .from(tabel)
    .update({ deleted_at: nu, updated_at: nu })
    .eq('id', id)
    .is('deleted_at', null)
    .select('id');
  if (error) throw error;
  if (!data?.length) throw new Error(`${wat} is al gearchiveerd, of je mag hem niet wijzigen. Laad de pagina opnieuw.`);
}

export async function archiveerOrganisatie(client: RelatieClient, id: string): Promise<void> {
  /* vlak vóór het schrijven opnieuw kijken: de pagina kan een oude stand tonen */
  const { data, error } = await client.from('projects').select('id').eq('org_id', id).is('deleted_at', null);
  if (error) throw error;
  const bezwaar = archiveerBezwaar((data ?? []).length);
  if (bezwaar) throw new ArchiveerWeigering(bezwaar);
  await zetGearchiveerd(client, 'organizations', id, 'Deze organisatie');
}

export async function archiveerContact(client: RelatieClient, id: string): Promise<void> {
  await zetGearchiveerd(client, 'contacts', id, 'Dit contact');
}
